import { STATIONS, STATION_BATCH } from "@/lib/mock";
import { cn } from "@/lib/cn";
import { cevir } from "@/lib/dil";

const toplam = STATIONS.map((_, i) => Object.values(STATION_BATCH).reduce((a, r) => a + (r[i] ?? 0), 0));
const dikkat: Record<string, number> = { S2: 1, S5: 2, S6: 4, S9: 1, SERT: 1 };

/**
 * Süreç rayı: S1→S11 + SERT, istasyon başına komponent sayısı ve dikkat rozeti.
 * Konsept B'de ana gezinme, Konsept A (melez) içinde Komuta sayfasının durum şeridi.
 */
export function SurecRayi({
  aktif,
  onSec,
  font = "manrope",
}: {
  aktif: string | null;
  onSec: (code: string | null) => void;
  font?: "manrope" | "plex";
}) {
  return (
    <div className={cn("scroll-none overflow-x-auto", font === "plex" ? "font-plex" : "font-manrope")}>
      <ol className="flex min-w-max items-stretch gap-1">
        {STATIONS.map((s, i) => {
          const n = toplam[i] ?? 0;
          const d = dikkat[s.code];
          const on = aktif === s.code;
          const sert = s.code === "SERT";
          return (
            <li key={s.code} className={cn(sert && "ml-2 border-l border-dashed border-line-strong pl-3")}>
              <button
                onClick={() => onSec(on ? null : s.code)}
                aria-pressed={on}
                className={cn(
                  "relative flex h-[52px] min-w-[92px] flex-col justify-center rounded-lg border px-3 text-left transition",
                  on ? "border-orange bg-orange-soft" : "border-line bg-surface hover:border-line-strong",
                  n === 0 && !on && "opacity-60",
                )}
              >
                <span className="flex items-center gap-1.5">
                  <span className="font-mono text-2xs text-ink-3">{s.code}</span>
                  <span className="text-sm font-bold">{s.kisa}</span>
                </span>
                <span className="mt-0.5 flex items-center gap-1.5 text-xs text-ink-2">
                  <span className="tnum">{n} {cevir("comp.")}</span>
                  {d ? <span className="rounded-full bg-bad px-1.5 text-2xs font-bold text-white tnum">{d}</span> : null}
                </span>
                {n > 0 && (
                  <span className="absolute inset-x-2 bottom-0 h-[3px] rounded-t bg-surface-3">
                    <span className="block h-full rounded-t bg-navy" style={{ width: `${Math.min(100, (n / 52) * 100)}%` }} />
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
